<template>
<div class="modal-mask" transition="modal" @click="cancel">
  <div class="modal-wrapper">
    <div class="modal-container modal-transition-container" @click.stop>
      <div class="modal-body">
        <slot name="content"></slot>
      </div>
      <div class="modal-footer">
        <button class="btn" @click.stop="cancel">
          <slot name="cancel">{{ $t('cancel') }}</slot>
        </button>
        <button class="btn btn-primary" @click.stop="ok">
          <slot name="ok">{{ $t('ok') }}</slot>
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// Generic OK/Cancel modal component
// Showing or hiding the modal is handled by the parent component
export default {
  methods: {
    ok: function () {
      this.$emit('ok')
    },
    cancel: function () {
      this.$emit('cancel')
    },
    keypressed: function (event) {
      let esc = 27
      if (event.keyCode === esc) {
        this.cancel()
      }
    }
  },
  mounted: function () {
    window.addEventListener('keyup', this.keypressed)
  },
  beforeDestroy: function () {
    window.removeEventListener('keyup', this.keypressed)
  }
}
</script>



// WEBPACK FOOTER //
// ConfirmModal2.vue?a5d49e9c